interface PhoneNumberOptions {
  type?: "withPlus" | "withoutPlus" | "onlyNumber" | "withPlusNoSpaces";
}

// Helper function to ensure phone number starts with 998 (Uzbekistan country code)
const ensureUzbekistanCode = (cleanNumber: string): string => {
  // If the number doesn't start with 998, add it
  if (!cleanNumber.startsWith('998')) {
    return '998' + cleanNumber;
  }
  return cleanNumber;
};

export const parsePhoneNumber = (
  phoneNumber: string,
  { type = "withPlus" }: PhoneNumberOptions = {},
): string => {
  const cleanNumber = phoneNumber?.replace(/\D/g, "");

  // If empty or very short, return as is
  if (!cleanNumber || cleanNumber.length < 3) {
    return phoneNumber;
  }

  // Ensure the number starts with 998 (Uzbekistan country code)
  const numberWithCountryCode = ensureUzbekistanCode(cleanNumber);

  // Limit to 12 digits maximum
  const limitedNumber = numberWithCountryCode.substring(0, 12);
  
  // If we have less than 12 digits, format what we have
  if (limitedNumber.length < 12) {
    switch (type) {
      case "withPlus":
        if (limitedNumber.length <= 3) {
          return `+${limitedNumber}`;
        } else if (limitedNumber.length <= 5) {
          return `+${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3)}`;
        } else if (limitedNumber.length <= 8) {
          return `+${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3, 5)} ${limitedNumber.substring(5)}`;
        } else {
          return `+${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3, 5)} ${limitedNumber.substring(5, 8)} ${limitedNumber.substring(8)}`;
        }
      case "withPlusNoSpaces":
        return `+${limitedNumber}`;
      case "withoutPlus":
        if (limitedNumber.length <= 3) {
          return limitedNumber;
        } else if (limitedNumber.length <= 5) {
          return `${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3)}`;
        } else if (limitedNumber.length <= 8) {
          return `${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3, 5)} ${limitedNumber.substring(5)}`;
        } else {
          return `${limitedNumber.substring(0, 3)} ${limitedNumber.substring(3, 5)} ${limitedNumber.substring(5, 8)} ${limitedNumber.substring(8)}`;
        }
      case "onlyNumber":
        return limitedNumber;
      default:
        return phoneNumber;
    }
  }

  // Full 12 digit formatting
  const [, code, part1, part2, part3] =
    limitedNumber.match(/^(\d{3})(\d{2})(\d{3})(\d{4})$/) || [];

  if (!code || !part1 || !part2 || !part3) return phoneNumber;

  switch (type) {
    case "withPlus":
      return `+${code} ${part1} ${part2} ${part3}`;
    case "withPlusNoSpaces":
      return `+${limitedNumber}`;
    case "withoutPlus":
      return `${code} ${part1} ${part2} ${part3}`;
    case "onlyNumber":
      return limitedNumber;
    default:
      return phoneNumber;
  }
};
